import { useState } from 'react';
import {
  AssignProductToDosageDiaryModalProps,
  ReactSelectOptionProp,
} from '../interface/interface';
import CustomModal from './CustomModal';
import Select from 'react-select';
import { useToFetchAvailableDosageDiaryProducts } from '../hooks/useToFetchAvailableDosageDiaryProducts';
import { useAuth } from 'react-oidc-context';
import { DocumentCard } from './DocumentCard';
import { useToAssignDosageDiary } from '../hooks/useToAssignProductsToDosageDiary';

export function AssignProductToDosageDiaryModal({
  isVisible,
  setVisibility,
  profileName,
  profileId,
  setCounter,
  invoke,
}: AssignProductToDosageDiaryModalProps) {
  const { user } = useAuth();
  const [loading, products, setProducts] =
    useToFetchAvailableDosageDiaryProducts(user!.access_token, invoke);
  const [selectedItems, setSelectedItems] = useState<
    Array<ReactSelectOptionProp>
  >([]);
  const [addProductToList] = useToAssignDosageDiary(
    user!.access_token,
    profileId,
    setCounter,
  );

  return (
    <CustomModal
      isOpen={isVisible}
      onClose={() => {
        setVisibility(false);
        setSelectedItems([]);
      }}
      header={`Assign Products to ${profileName}`}
      modalSize="w-5/12"
      footer={
        <button
          className={`rounded-md text-white text-base px-6 py-3 
            ${selectedItems.length ? 'bg-primary-blue-500' : 'bg-primary-blue-200 cursor-not-allowed'} `}
          onClick={() => {
            setVisibility(false);
            addProductToList(selectedItems.map((e) => parseInt(e.value)));
            setSelectedItems([]);
          }}
          disabled={selectedItems.length === 0}
        >
          Assign Products
        </button>
      }
    >
      <div className="py-4">
        <Select
          placeholder="Search Products"
          options={products}
          isLoading={loading}
          value={null}
          onChange={(e) => {
            if (e) {
              // Remove it from the product list
              setProducts((prev) => prev.filter((p) => p.value !== e.value));
              // Add it to the selected list
              setSelectedItems((prev) => [...prev, e]);
            }
          }}
        />

        {selectedItems.length ? (
          <div className="content pt-6">
            <p className="font-semibold">Selected Products:</p>
            <div className="py-4 max-h-64 overflow-y-auto">
              <DocumentCard
                item={selectedItems.map((e) => ({
                  name: e.label,
                  size: '',
                  onDelete: () => {
                    // Find the product in selected item list
                    const removedItem = selectedItems.find(
                      (item) => item.value === e.value,
                    );

                    if (removedItem) {
                      setSelectedItems((prev) =>
                        prev.filter((p) => p.value !== removedItem.value),
                      );
                      setProducts((p) => [...p, removedItem]);
                    }
                  },
                }))}
              />
            </div>
          </div>
        ) : null}
      </div>
    </CustomModal>
  );
}
